export default (that) => [
  {
    text: that.$l('menu_text_detail') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('menu_text_edit') || '编辑单据',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: true,
    allow: 'M',
    disabled: ({ amzPurchaseStatus }) => {
      return !['N', 'R'].includes(amzPurchaseStatus)
    },
  },
  {
    text: that.$l('menu_text_delete') || '删除单据',
    icon: 'el-icon-delete',
    menuType: 'delete',
    allow: 'D',
    disabled: ({ amzPurchaseStatus }) => {
      return !['N', 'R'].includes(amzPurchaseStatus)
    },
  },
  {
    text: that.$l('menu_text_submit') || '提交审核',
    icon: 'el-icon-s-check',
    menuType: 'submit',
    divided: true,
    allow: 'S',
    disabled: ({ amzPurchaseStatus }) => {
      return !['N', 'R'].includes(amzPurchaseStatus)
    },
  },
  {
    text: that.$l('menu_text_audit') || '审核单据',
    icon: 'el-icon-check',
    menuType: 'audit',
    allow: 'Y',
    disabled: ({ amzPurchaseStatus }) => amzPurchaseStatus !== 'S',
  },
  {
    text: that.$l('menu_text_change') || '产品变更',
    icon: 'el-icon-edit-outline',
    menuType: 'change',
    divided: true,
    allow: 'C',
    disabled: ({ amzPurchaseStatus }) => amzPurchaseStatus !== 'Y',
  },
  {
    text: that.$l('menu_text_export') || '导出合同',
    icon: 'el-icon-download',
    menuType: 'export',
    divided: true,
    allow: 'E',
    disabled: ({ amzPurchaseStatus }) => amzPurchaseStatus !== 'Y',
  },
]
